import React, { memo } from 'react';
import PropTypes from 'prop-types';
import './ConfirmActions.css';

const ConfirmModal = memo(function CModal(props) {
  const {
    show,
    title,
    onClick,
    subtitle,
    setShowConfirmModal,
    confirmModalBtnText,
    additionalComponent,
    onCancelClick = () => {},
  } = props;

  return show ? (
    <div
      data-test="confirm-modal"
      className="h-screen w-screen fixed top-0 left-0 backdrop-blur-sm  flex justify-center items-center transition-all duration-1000 ease-in-out"
      style={{ zIndex: 1501 }}
    >
      <div className="w-3/6  bg-white rounded-md z-50 shadow-2xl opacity-100 duration-1000 ease-in-out relative">
        <div className="flex justify-end absolute right-1 top -1">
          <button
            type="button"
            className="cursor-pointer transition-transform duration-700 hover:rotate-90 hover:text-primary text-black"
            onClick={() => {
              onCancelClick();
              setShowConfirmModal(false);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="icon icon-tabler icons-tabler-outline icon-tabler-x m-2 text-inherit"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M18 6l-12 12" />
              <path d="M6 6l12 12" />
            </svg>
          </button>
        </div>
        <h2 className=" mt-4 font-bold text-lg text-center poppins-bold text-dark-night">
          {title}
        </h2>

        <div className="flex flex-col justify-center items-center mt-2 ">
          <p className="font-bold  mr-4 mb-0 poppins-bold text-dark-night">{`${subtitle}`}</p>
          {additionalComponent}
        </div>

        <div className="flex justify-center pb-4  mt-2">
          <button
            data-test="confirm-modal-submit"
            type="button"
            className="bg-[#FF5E00]  text-[12px] hover:scale-x-105 hover:scale-y-105 transition duration-500 z-30 shadow-md  w-32 h-12 rounded-[15px] text-white  poppins-bold px-2 "
            onClick={() => {
              onClick();
              setShowConfirmModal(false);
            }}
          >
            {confirmModalBtnText}
          </button>
        </div>
      </div>
    </div>
  ) : null;
});

ConfirmModal.propTypes = {
  show: PropTypes.bool,
  title: PropTypes.string,
  onClick: PropTypes.func,
  subtitle: PropTypes.string,
  setShowConfirmModal: PropTypes.func,
  confirmModalBtnText: PropTypes.string,
  additionalComponent: PropTypes.func,
  onCancelClick: PropTypes.func,
};

export default ConfirmModal;
